import * as React from 'react'
import TextField from '@material-ui/core/TextField'
import Select from 'react-select'

const deliveryTimes = [
  { value: '8AM-12PM', label: '8AM-12PM' },
  { value: '12PM-5PM', label: '12PM-5PM' },
]

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    background: '#fff',
    borderColor: '#9e9e9e',
    height: '55px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '55px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '55px',
  }),
}

const OrderForm = React.forwardRef(({ defaultData }, ref) => {
  const contactPersonRef = React.useRef(null)
  const contactDetailsRef = React.useRef(null)
  const deliveryAddressRef = React.useRef(null)
  const paymentTypeRef = React.useRef(null)
  const deliveryTimeRef = React.useRef(null)
  const deliveryDateRef = React.useRef(null)
  const deliveryNoteRef = React.useRef(null)

  const submitData = () => {
    return {
      contactPerson: contactPersonRef.current.value,
      contactDetails: contactDetailsRef.current.value,
      deliveryAddress: deliveryAddressRef.current.value,
      deliveryNote: deliveryNoteRef.current.value,
      deliveryDate: deliveryDateRef.current.value,
      paymentType: paymentTypeRef.current?.getValue()[0]?.value ?? null,
      deliveryTime: deliveryTimeRef.current?.getValue()[0]?.value ?? null,
    }
  }

  React.useImperativeHandle(ref, () => ({
    submitData: submitData,
  }))


  const textFields = [
    {
      placeholder: 'Contact Person Name *',
      ref: contactPersonRef,
      size: '50%',
      defaultValue: defaultData?.contactPerson || '',
    },
    {
      placeholder: 'Contact Details *',
      ref: contactDetailsRef,
      size: '50%',
      defaultValue: defaultData?.contactDetails || '',
    },
    {
      placeholder: 'Delivery Address *',
      ref: deliveryAddressRef,
      size: '100%',
      defaultValue: defaultData?.deliveryAddress || '',
    },
    {
      placeholder: 'Delivery Note',
      ref: deliveryNoteRef,
      size: '100%',
    },
  ]

  const today = new Date().toISOString().split('T')[0]

  return (
    <div
      className="checkout-details"
      style={{
        backgroundColor: '#ffff',
        padding: '20px',
        borderRadius: '5px',
      }}
    >
      <h2>Delivery & contact details</h2><p className="checkout-details-hint">Tell us where and when to deliver. Fields marked * are required.</p><div className="checkout-fields">
      {textFields.map((field, index) => (
        <div
          key={index}
          className={field.size === '100%' ? 'checkout-field checkout-field-wide' : 'checkout-field'}
          style={{
            width: field.size || '100%',
            display: 'inline-block',
            verticalAlign: 'top',
          }}
        >
          <TextField
            id={`checkout-contact-field-${index}`}
            variant="outlined"
            placeholder={field.placeholder}
            label={field.placeholder}
            InputLabelProps={{ shrink: true }}
            fullWidth
            inputRef={field.ref}
            defaultValue={field.defaultValue || ''}
          />
        </div>
      ))}
      <div
        className="checkout-field checkout-schedule"
        style={{
          width: '25%',
          display: 'inline-block',
          verticalAlign: 'top',
          marginTop: '10px',
        }}
      >
        <label htmlFor="checkout-delivery-date">Preferred Delivery Date *</label>
        <TextField
          variant="outlined"
          id="checkout-delivery-date"
          placeholder={'Preferred Delivery Date *'}
          fullWidth
          inputRef={deliveryDateRef}
          type="date"
          inputProps={{ min: today }}
          defaultValue={defaultData?.deliveryDate || today}
        />
      </div>
      <div
        className="checkout-field checkout-schedule"
        style={{
          width: '25%',
          display: 'inline-block',
          verticalAlign: 'top',
          marginTop: '10px',
        }}
      >
        <label htmlFor="checkout-payment-type">Payment Type *</label>
        <Select
          inputId="checkout-payment-type"
          options={[
            { value: 'Cash', label: 'Cash' },
            { value: 'Check', label: 'Check' },
            { value: 'Credit Card On File', label: 'Credit Card On File' },
          ]}
          placeholder="Payment Type *"
          ref={paymentTypeRef}
          styles={customSelectStyles}
        />
      </div>
      <div
        className="checkout-field checkout-schedule"
        style={{
          width: '50%',
          display: 'inline-block',
          verticalAlign: 'top',
          marginTop: '10px',
        }}
      >
        <label htmlFor="checkout-delivery-time">Preferred Delivery Time *</label>
        <Select
          inputId="checkout-delivery-time"
          options={deliveryTimes}
          placeholder="Preferred Delivery Time *"
          ref={deliveryTimeRef}
          styles={customSelectStyles}
        />
      </div>
      </div>
    </div>
  )
})

export default OrderForm
